import { Button } from 'react-bootstrap';
import { CommonProperties } from '../common.interfaces';

interface EnvironmentSelectionProps {
  setEnvironment: (env: 'production' | 'development') => void;
  environment: string
}

export const EnvironmentSelection: React.FC<EnvironmentSelectionProps> = ({ setEnvironment, environment }) => {
  return (
    <>
      <Button onClick={() => {setEnvironment('development')}} variant={environment === 'development' ? 'secondary' : 'outline-secondary'}>SANDBOX</Button>&nbsp;
      <Button onClick={() => {setEnvironment('production')}} variant={environment === 'development' ? 'outline-secondary' : 'secondary'}>PRODUCTION</Button>
    </>
  );
};